module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Light.a79ab03.otf";